<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Lịch sử thanh toán', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <date-range
          title="Lịch sử thanh toán"
          v-model="daterange"
          class="mx-1"
        ></date-range>
        <div class="ml-2 mr-2">
          <hr />
          <b-row>
            <b-col>
              <b-button block v-b-toggle.advSearch variant="primary">
                <i class="fa fa-binoculars"></i> Tìm kiếm nâng cao
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="printDebt" block variant="success">
                <i class="fa fa-print"></i> In toàn bộ
              </b-button>
            </b-col>
            <b-col>
              <download-excel
                class="btn btn-primary btn-block"
                :data="debtTables"
                :fields="debtFields"
                :worksheet="worksheet"
                name="cong-no.xls"
              >
                <i class="fa fa-file-export"></i>
                Xuất file Excel
              </download-excel>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="advSearch" class="mt-2">
                <b-card>
                  <b-row>
                    <b-col md="4">
                      <base-input v-model="searcAdv.search" label="Từ khóa">
                      </base-input>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        v-model="searcAdv.customer"
                        label="Khách hàng"
                        :ajaxData="getCustomer"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        label="Người phụ trách"
                        v-model="searcAdv.user"
                        :ajaxData="getUser"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div class="d-flex">
                            <span class="avatar avatar-sm rounded-circle mr-2">
                              <img
                                v-holder="{
                                  img: '40x40',
                                  text: item.name
                                }"
                                @error="$imgHolder"
                                :alt="item.name"
                                :src="$mediaURI + item.avatar"
                              />
                            </span>
                            <div>
                              <strong>{{ item.name }}</strong>
                              <br />
                              <span>{{ item.phone }}</span>
                            </div>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="12">
                      <hr />
                      <b-button @click="fetchData" block variant="secondary ">
                        <i class="fa fa-search"></i> Tìm kiếm</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <div class="mt-3">
          <time-line
            :data="timelines"
            v-model="timelineSelect"
            @timelineClick="timelineClick"
          ></time-line>
        </div>
        <template>
          <b-card class="mb-3 m-2" no-body>
            <b-card-header
              header-tag="header"
              class="p-1 d-flex justify-content-between align-items-center"
            >
              <div class="text-center d-block">
                <b>{{ timelineSelect.text }}</b> (<span>{{
                  timelineSelect.start
                }}</span
                >- <span>{{ timelineSelect.end }}</span
                >)
              </div>
            </b-card-header>
            <b-card-body class="px-2">
              <!-- <div
                class="timeline timeline-one-side"
                data-timeline-content="axis"
                data-timeline-axis-style="dashed"
              >
                <div
                  v-for="(item, index) in debtTables"
                  :key="index"
                  class="timeline-block"
                >
                  <span class="timeline-step badge-success">
                    <span class="avatar avatar-sm rounded-circle">
                      <img
                        v-holder="{
                          img: '40x40',
                          text: item.avatar
                        }"
                        @error="$imgHolder"
                        :alt="item.name"
                        :src="$mediaURI + item.avatar"
                      />
                    </span>
                  </span>
                  <div
                    class="timeline-content"
                    style="width:auto; max-width:unset"
                  >
                    <h5 class="mb-2">{{ item.name }} - {{ item.username }}</h5>
                    <template v-for="(customer, index) in item.customer">
                      <b-card :key="index">
                        <div>
                          {{ customer.name }}
                        </div>
                        <template v-for="(cur, i) in customer.currencys">
                          <div
                            :key="i"
                            style="min-height: 95px; margin-bottom:20px"
                            class="table-responsive base-table table-soft b-table-sticky-header"
                          >
                            <table
                              class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                            >
                              <thead>
                                <tr>
                                  <th>STT</th>
                                  <th>Ngày tạo</th>
                                  <th class="text-left">Mã Phiếu xuất</th>
                                  <th class="text-left">Người Tạo phiếu</th>
                                  <th class="text-right">Tổng tiền</th>
                                  <th class="text-right">Đã thanh toán</th>
                                  <th class="text-right">Còn lại</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(row, index) in customer.receiptBill"
                                  :key="index"
                                >
                                  <template v-if="row.currency == cur.currency">
                                    <td class="bg-info text-light col-fix ">
                                      {{ index + 1 }}
                                    </td>
                                    <td class="text-left">
                                      {{ $dateUnix(row.dateCreated) }}
                                    </td>
                                    <td class="text-left">{{ row.code }}</td>
                                    <td class="text-left">
                                      {{ row.userCreated.name }}
                                    </td>
                                    <td class="text-right">
                                      {{ $formatNumber(row.total) }}
                                      {{ cur.currency }}
                                    </td>
                                    <td class="text-right">
                                      {{ $formatNumber(row.paid) }}
                                      {{ cur.currency }}
                                    </td>
                                    <td class="text-right">
                                      {{ $formatNumber(row.total - row.paid) }}
                                      {{ cur.currency }}
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="4">Tổng cộng</td>
                                  <td class="text-right">
                                    {{ $formatNumber(cur.summarry.total) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{ $formatNumber(cur.summarry.paid) }}
                                    {{ cur.currency }}
                                  </td>
                                  <td class="text-right">
                                    {{
                                      $formatNumber(
                                        cur.summarry.total - cur.summarry.paid
                                      )
                                    }}
                                    {{ cur.currency }}
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </template>
                      </b-card>
                    </template>
                  </div>
                </div>
              </div> -->
              <soft-table
                @rowSelected="tbSetRowSelected"
                @rowClicked="tbRowClicked"
                class="table align-items-center table-flush"
                tbody-classes="list"
                :pending="false"
                :showAll="true"
                :dataTable="debtTables"
                :fields="fields"
                :minHeight="$hControl"
                @contextMenuItemClick="tbHandleContextMenuItemClick"
                ref="soft-table"
              >
                <template v-slot:cell(info)="{ item }">
                  <div class="d-flex" style="min-width:200px">
                    <span class="avatar avatar-sm rounded-circle">
                      <img
                        v-holder="{
                          img: '40x40',
                          text: item.info.code
                        }"
                        @error="$imgHolder"
                        :alt="item.info.name"
                        :src="$mediaURI + item.info.avatar"
                      />
                    </span>
                    <ul class="ml-2">
                      <li>Mã KH : {{ item.info.code }}</li>
                      <li>Tên KH : {{ item.info.name }}</li>
                    </ul>
                  </div>
                </template>
                <template v-slot:cell(info.userManage)="{ value }">
                  {{ value.name }}
                </template>
                <template v-slot:cell(currencys)="{ value }">
                  <ul class="text-right">
                    <li v-for="(cur, index) in value" :key="index">
                      <span>{{ $formatNumber(cur.amount) }}</span>
                      <b> {{ cur.currency }}</b>
                    </li>
                  </ul>
                </template>
                <template v-slot:cell(code)="row">
                  <b-button @click="row.toggleDetails" variant="link">
                    Xem lịch sử giao dịch
                  </b-button>
                </template>
                <template v-slot:cell(name)="row">
                  <b-button @click="row.toggleDetails" variant="link">
                    {{ row.value }}
                  </b-button>
                </template>
                <template v-slot:row-details="row">
                  <div class="py-2" style="background:#fff">
                    <template v-for="(cur, i) in row.item.currencys">
                      <div
                        :key="i"
                        style="min-height: 95px; margin-bottom:20px"
                        class="table-responsive base-table table-soft b-table-sticky-header"
                      >
                        <table
                          class="table tablesorter b-table b-table-no-border-collapse b-table-selectable b-table-select-range b-table-selecting"
                        >
                          <thead>
                            <tr>
                              <th>STT</th>
                              <th class="text-right">Ngày thanh toán</th>
                              <th>Mã giao dịch</th>
                              <th class="text-left">
                                Phương thức thanh toán
                              </th>
                              <th class="text-center">Ghi chú</th>
                              <th class="text-right col-fix">Số tiền</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(transaction, index) in row.item.data"
                              :key="index"
                            >
                              <template
                                v-if="transaction.currency == cur.currency"
                              >
                                <td class="bg-info text-light col-fix ">
                                  {{ index + 1 }}
                                </td>
                                <td class="text-center col-fix">
                                  {{ $dateUnix(transaction.dateCreated) }}
                                </td>
                                <td class="text-left  col-fix">
                                  {{ transaction.transaction }}
                                </td>
                                <td class="text-center  col-fix">
                                  <!-- {{ transaction.method }} -->
                                  <select
                                    disabled
                                    v-model="transaction.method"
                                    id="method_payment"
                                  >
                                    <option value="0">Không rõ</option>
                                    <option value="1">Chuyển khoản</option>
                                    <option value="2">Tiền mặt</option>
                                  </select>
                                </td>
                                <td class="text-center">
                                  {{ transaction.note }}
                                </td>
                                <td class="text-right">
                                  {{ $formatNumber(transaction.amount) }}
                                  {{ cur.currency }}
                                </td>
                              </template>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="5">Tổng cộng</td>
                              <td class="text-right">
                                {{ $formatNumber(cur.amount) }}
                                {{ cur.currency }}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </template>
                  </div>
                </template>
              </soft-table>
            </b-card-body>
            <b-card v-if="debtTables.length == 0" class="m-2">
              <h4>Chưa có đơn hàng nào trong khoản thời gian này</h4>
            </b-card>
          </b-card>

          <!-- <b-card
            class="mb-3 m-2"
            no-body
            v-for="(item, index) in debtTables"
            :key="index"
          >
            <b-card-header
              header-tag="header"
              class="p-1 d-flex justify-content-between align-items-center"
            >
              <b-button variant="link" href="#" v-b-toggle="item.key">
                <span>{{ item.month }}</span>
              </b-button>
            </b-card-header>
            <b-collapse visible :id="item.key">
              <b-card-body class="px-2"> </b-card-body>
            </b-collapse>
          </b-card> -->
        </template>
      </block>
    </div>
    <preview ref="preview"></preview>
  </div>
</template>
<script>
import { receiptService, userService, customerService } from "@/_services";
import { addDateTime } from "@/utils/date";
import JsonExcel from "vue-json-excel";

import { mapState } from "vuex";

import Preview from "./__Preview";
export default {
  name: "history-payment",
  components: {
    Preview,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        from: addDateTime(-6),
        to: new Date()
      },
      searcAdv: {
        search: "",
        customer: "",
        user: ""
      },
      daterange: {},
      debtTables: [],
      worksheet: "Công nợ",
      debtFields: {
        STT: "stt",
        "Mã khách hàng": "customer.code",
        "Tên khách hàng": "customer.name",
        "Mã phiếu xuất": "code",
        "Người tạo phiếu": "userCreated.name",
        "Tổng tiền": "total",
        "Đã thanh toán": "paid",
        "Còn lại": {
          callback: value => {
            return `${value.total - value.paid}`;
          }
        },
        "Loại tiền": "currency",
        "Ngày tạo": {
          callback: value => {
            return this.$dateUnix(value.dateCreated);
          }
        }
      },
      lastIndexCustomerSelected: 0,
      debts: [],
      timelines: [
        { text: "06/2020" },
        { text: "07/2020" },
        { text: "08/2020" },
        { text: "09/2020" }
      ],
      timelineSelect: {
        text: ""
      },
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "col-fix checkbox"
        },
        {
          key: "info",
          label: "Thông tin khách hàng",
          sortable: true
        },
        {
          key: "info.userManage",
          label: "Người phụ trách",
          sortable: true,
          class: "col-fix"
        },
        {
          key: "currencys",
          label: "Số tiền thanh toán",
          sortable: true
        },
        {
          key: "code",
          label: "Lịch sử",
          sortable: true,
          class: "text-center"
        }
      ],
      allCurrency: []
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  mounted() {
    setTimeout(() => {
      this.daterange = {
        from: addDateTime(-6),
        to: new Date()
      };
    }, 100);
  },
  methods: {
    fetchData() {
      this.listQuery.from = this.timelineSelect.start;
      this.listQuery.to = this.timelineSelect.end;
      if (this.searcAdv.user) {
        this.listQuery.userId = this.searcAdv.user.id;
      } else {
        this.listQuery.userId = "";
      }
      if (this.searcAdv.customer) {
        this.listQuery.customerId = this.searcAdv.customer.id;
      } else {
        this.listQuery.customerId = "";
      }
      this.listQuery.search = this.searcAdv.search;

      this.worksheet = `${this.$date(
        this.daterange.from,
        "DD_MM_YYYY"
      )} - ${this.$date(this.daterange.to, "DD_MM_YYYY")}`;
      this.allCurrency = [];
      receiptService.historyPayment(this.listQuery).then(res => {
        let transactions = res.data.data;
        this.debtTables = [];
        let customers = [];
        transactions.forEach(transaction => {
          let code = transaction.customer.code;
          this.allCurrency[transaction.currency] = transaction.currency;

          if (customers[code] && customers[code].data) {
            customers[code].data.push(transaction);
            let currency = this.checkItemInArray(
              customers[code].currencys,
              transaction.currency,
              "currency"
            );
            if (!currency || currency == false) {
              let currencySummarry = {
                currency: transaction.currency,
                amount: transaction.amount
              };
              customers[code].currencys.push(currencySummarry);
            } else {
              currency.amount += transaction.amount;
            }
          } else {
            let currencySummarry = {
              currency: transaction.currency,
              amount: transaction.amount
            };

            customers[code] = {
              info: transaction.customer,
              code: code,
              data: [transaction],
              currencys: [currencySummarry]
            };
          }
        });
        this.debtTables = Object.values(customers);
        // this.debts.forEach(element => {
        //   element.customers = Object.values(element.customers);
        // });
        console.log(this.debtTables);
      });
    },
    timelineClick() {
      this.debtTables = [];
      this.fetchData();
    },
    checkItemInArray(arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element[key] == value) {
          return element;
        }
      }
      return false;
    },
    getUser(keyword, cb) {
      userService.adminGetAllUser({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push(this.info);
        data.push({
          id: -1,
          name: "Tất cả nhân viên"
        });
        cb(data);
      });
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push({
          id: -1,
          name: "Tất cả khách hàng"
        });
        cb(data);
      });
    },
    printDebt() {
      this.$refs.preview.visible = true;
      let debt = {
        from: this.daterange.from,
        to: this.daterange.to,
        data: this.debts
      };
      this.$refs.preview.setData(debt);
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    },
    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push([i, displayMonth, "01"].join("-"));
        }
      }
      return dates;
    }
  },
  watch: {
    daterange: function() {
      this.timelines = this.$dateRange(this.daterange.from, this.daterange.to);
      if (this.timelines.length > 0) {
        this.timelineSelect = this.timelines[this.timelines.length - 1];
      }
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
